import { useState } from "react";
import "@devexpress/dx-react-grid-bootstrap4/dist/dx-react-grid-bootstrap4.css";
import "open-iconic/font/css/open-iconic-bootstrap.css";
import {
  Grid,
  TableHeaderRow,
  TableTreeColumn,
  TableBandHeader,
  Table,
} from "@devexpress/dx-react-grid-bootstrap4";
import { CustomTreeData, TreeDataState } from "@devexpress/dx-react-grid";

export default function DataGrid({
  columnBands,
  rows,
  columns,
  tableColumnExtensions,
}) {
  const [columnExtensions] = useState(
    tableColumnExtensions ? tableColumnExtensions : null
  );

  const TableComponent = ({ ...restProps }) => (
    <Table.Table {...restProps} className="table-striped" />
  );

  const getChildRows = (row, rootRows) => {
    const childRows = rootRows.filter(
      (r) => r.parentId === (row ? row.id : null)
    );
    return childRows.length ? childRows : null;
  };

  const getRowId = (row) => row.id;

  return (
    <div className="card">
      <Grid rows={rows} columns={columns} getRowId={getRowId}>
        <TreeDataState />
        <CustomTreeData getChildRows={getChildRows} />

        <Table
          columnExtensions={columnExtensions}
          striped={true}
          tableComponent={TableComponent}
        />

        <TableHeaderRow />

        <TableTreeColumn for="title" visible="true" />
        <TableBandHeader columnBands={columnBands} />
      </Grid>
    </div>
  );
}
